import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Stethoscope } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-neu-bg gap-4">
        <div className="w-16 h-16 rounded-2xl neu-card flex items-center justify-center animate-pulse">
          <Stethoscope className="w-8 h-8 text-neu-accent" />
        </div>
        <p className="heading text-lg">Loading FellowLog…</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/signin" replace />;
  return children;
}
